import React from "react";
import { Link } from "react-router-dom";
import Champ from "../images/Champ";
import useFetch from "../hooks/useFetch";
import { servers } from "../misc/Static";
import styles from "./LivePanel.module.css";

export const LivePanel = ({ region, pid }) => {
  const URL = `https://pp${servers[region]}.xdx.gg/live/1/${region}/${pid}/`;
  const key = region + pid;
  const data = useFetch(URL, key)[key];

  const caseTier = (tier) => {
    let tiers = tier.split(" ");
    tiers[0] = tiers[0].toLowerCase();
    return ["challenger", "grandmaster", "master"].indexOf(tiers[0]) !== -1
      ? tiers[0]
      : tiers.join(" ");
  };

  if (!data || !data.players) return <></>;
  return (
    <div className={styles.livegame}>
      <h3>Live Game</h3>
      <div>
        {data.players.map((team, i) => (
          <div className={styles["team" + i]} key={i}>
            {team.map((player, j) => (
              <div key={j}>
                <div>
                  <div>
                    <Link
                      to={{
                        pathname: `/${player[0]
                          .replace(/\s+/g, "")
                          .replace(/#/g, "-")
                          .toLowerCase()}`,
                      }}
                    >
                      {player[0]}
                    </Link> 
                  </div>
                  <div>{caseTier(player[3])}</div>
                </div>
                <Champ type="champ24b" id={parseInt(player[1])} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LivePanel;
